import moment from 'moment';
import { FC } from 'react';
import { Card, Checkbox } from 'rsuite';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RichProductNativeCreativePreview } from 'components/CreativePreview/RichProductNativePreview';
interface CreativeCardProps {
  creative: any;
  checked: boolean;
  onCheck: (value: any, checked: boolean) => void;
}
const CreativeCard: FC<CreativeCardProps> = ({
  creative,
  checked,
  onCheck,
}) => {
  const handleCheck = (value, checked) => {
    onCheck(creative.id.toString(), checked);
  };
  return (
    <Card
      bordered
      className={
        checked
          ? 'row-auto justify-around !border-2 !border-[#413993]'
          : 'row-auto justify-around'
      }
      shaded='hover'
    >
      <Card.Header className='p-0'>
        <Checkbox onChange={handleCheck} checked={checked} />
      </Card.Header>
      <Card.Body className='h-max p-0'>
        <div className='flex min-h-[250px] flex-col justify-around p-3'>
          <div className='flex min-h-[160px] items-center justify-center'>
            {(creative.creativeType === 1 || creative.creativeType === 9) && (
              <img
                src={creative.bannerImageUrl}
                className='h-auto w-full'
                alt=''
              />
            )}
            {creative.creativeType === 14 && (
              <span className='inline-block w-full text-center'>
                品牌: {creative.creativeValue?.brandName}
              </span>
            )}
            {creative.creativeType === 12 && (
              <RichProductNativeCreativePreview creative={creative} />
            )}
          </div>
          <div className=''>
            <span className='inlin-block'>{creative.name}</span>
          </div>
        </div>
        <div className='border-top min-h-[50px] w-full border-gray-200 p-1'>
          {creative.landingPageUrl && (
            <span className='inline-block max-w-[210px] grow overflow-hidden break-all text-xs leading-5 text-gray-600'>
              {creative.landingPageUrl}
              <a
                href={creative.landingPageUrl}
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon icon={faShareSquare} className='ml-1' />
              </a>
            </span>
          )}
        </div>
        <div className='border-top border- grid grid-cols-[1fr_2fr] gap-2'>
          <span className='inline-block pl-2 text-xs leading-5 text-gray-600'>
            ID: {creative.id}
          </span>
          <span className='border-left inline-block border-gray-200 pl-1 text-xs leading-5 text-gray-600'>
            {moment(creative.createTime).format('YYYY/MM/DD')} 建立
          </span>
        </div>
      </Card.Body>
      <Card.Footer className='p-0'></Card.Footer>
    </Card>
  );
};

export default CreativeCard;
